import { NavigateOptions, useRouter } from '@tanstack/react-router';
import { useCallback } from 'react';
import { EnterprisePaths, enterpriseRoutePrefix, ParamsProps, SearchProps } from './types';

export type EnterpriseNavigateOptions<To extends EnterprisePaths, From> = {
    to: To;
    from?: From;
    replace?: boolean;
} & ParamsProps<To> &
    SearchProps<To, From>;

export const useEnterpriseNavigate = () => {
    const { navigate } = useRouter();

    return useCallback(
        async <To extends EnterprisePaths, From extends string>({ to, ...rest }: EnterpriseNavigateOptions<To, From>) =>
            navigate({ to: `${enterpriseRoutePrefix}${to}`, ...rest } as NavigateOptions),
        [navigate]
    );
};
